import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BooleanCustomFieldConfig, SharedModule, FormInputComponent } from '@vendure/admin-ui/core';

@Component({
    template: `
        <input class="disabled-boolean-form" type="checkbox" [formControl]="formControl" clrCheckbox />
    `,
    styleUrls: ['./disabled-boolean-form.component.scss'],
    standalone: true,
    imports: [SharedModule],
})
export class DisabledBooleanFormComponent implements FormInputComponent<BooleanCustomFieldConfig> {
    readonly: boolean;
    config: BooleanCustomFieldConfig;
    formControl: FormControl;
}
